/* eslint-disable import/prefer-default-export */
import { useDispatch } from "react-redux";
import { display } from "redux-react/reducers/snackBarReducer";

export const useAppActions = () => {
	const dispatch = useDispatch();

	const showInfoMessage = message => {
		dispatch(display({ message, type: "info" }));
	};

	const showSuccessMessage = message => {
		dispatch(display({ message, type: "success" }));
	};

	const showErrorMessage = message => {
		dispatch(display({ message, type: "error" }));
	};

	return {
		showSuccessMessage,
		showErrorMessage,
		showInfoMessage
	};
};
